import { ButtonVariant } from "@repo/ui/Buttons/button";
import { IconButton } from "@repo/ui/Buttons/iconButton";
import { IconChevronLeft, IconChevronRight } from "@tabler/icons-react";
import type { FC } from "react";

interface PaginationControls {
  page: number;
  totalPages: number;
  onClickNextPage: () => void;
  onClickPreviousPage: () => void;
}

export const PaginationControls: FC<PaginationControls> = ({
  page,
  totalPages,
  onClickNextPage,
  onClickPreviousPage,
}) => {
  return (
    <div className="flex items-center space-x-2">
      <span className="mr-1 text-sm text-gray-600">
        Page {page} of {totalPages}
      </span>
      <IconButton
        variant={ButtonVariant.Secondary}
        onClick={onClickPreviousPage}
        isDisabled={page <= 1}
        icon={<IconChevronLeft className="h-4 w-4" />}
      ></IconButton>
      <IconButton
        variant={ButtonVariant.Secondary}
        onClick={onClickNextPage}
        isDisabled={page >= totalPages}
        icon={<IconChevronRight className="h-4 w-4" />}
      ></IconButton>
    </div>
  );
};
